import { createContext } from 'react';
import { useFiltersContext } from '../../../../Common/Filters/hooks/useFiltersContext';
import {
    QUERY_KEYS_VS,
    useChartsData
} from '../../../../Common/hooks/useChartsData';

export const ResultsChartsDataContext = createContext();

const ResultsChartsDataProvider = ({ children }) => {
    const { filters } = useFiltersContext();
    const { data, isLoading, isError } = useChartsData(
        {
            key: QUERY_KEYS_VS.RESULTS_MORTALITY,
            url: 'governanceroom/dashboard/vitalstatistics/mortality/results',
        },
        {
            data_inicio: filters.data_inicio,
            data_fim: filters.data_fim,
            location: filters.unidade.value,
            city: filters.cidade?.value,
        }
    );

    const chartData = data
        ? {
              indicators: {
                  averageDeathCertificateTime:
                      data?.indicators?.averageDeathCertificateTime ?? 0
              },
              monthlyDeaths: data?.monthlyDeaths ?? [],
              deathTime: data?.deathTime ?? [],
              annualDeaths: data?.annualDeaths ?? []
          }
        : {
              indicators: {
                  averageDeathCertificateTime: 0
              },
              monthlyDeaths: [],
              deathTime: [],
              annualDeaths: []
          };

    return (
        <ResultsChartsDataContext.Provider
            value={{
                chartData,
                isLoading,
                isError,
                filters,
                data
            }}
        >
            {children}
        </ResultsChartsDataContext.Provider>
    );
};

export default ResultsChartsDataProvider;
